import e from "@babel/runtime/helpers/esm/defineProperty";
import { createElement as r, forwardRef as t, createContext as o, useContext as i } from "react";
import s from "@babel/runtime/helpers/esm/objectWithoutProperties";
import c from "classnames";
import { Slider as n } from "../slider/index.js";
import { Quote as p } from "../quote/index.js";
import { jsx as l } from "react/jsx-runtime";
import "./lazyQuotesSlider.js";
import "@kickstartds/core/lib/container";
import "../slider/slider.css";
import "../slider/lazySlider.js";
import "@kickstartds/core/lib/core";
import "@kickstartds/base/lib/picture";
import "@kickstartds/base/lib/rich-text";
import "../quote/quote.css";
const m = ["slides", "className", "component"];
function a(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function b(r) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? a(Object(o), !0).forEach(function (t) {
      e(r, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : a(Object(o)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
    });
  }
  return r;
}
function u(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function f(r) {
  for (var t = 1; t < arguments.length; t++) {
    var o = null != arguments[t] ? arguments[t] : {};
    t % 2 ? u(Object(o), !0).forEach(function (t) {
      e(r, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : u(Object(o)).forEach(function (e) {
      Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
    });
  }
  return r;
}
const O = t((e, t) => {
  let {
      slides: o,
      className: i,
      component: a = "content.quotes-slider"
    } = e,
    u = s(e, m);
  return l(n, b(b({
    component: a,
    arrows: "outer",
    className: c("quotes-slider", i),
    ref: t
  }, u), {}, {
    children: null == o ? void 0 : o.map((e, t) => r(p, b(b({}, e), {}, {
      key: t
    })))
  }));
});
const j = o(O);
const y = t((e, t) => r(i(j), f(f({}, e), {}, {
  ref: t
})));
export { y as QuotesSlider, j as QuotesSliderContext, O as QuotesSliderContextDefault };